import { images } from './common';

export const fakeBacheloretteActivities = [
  {
    title: 'Lingerie Party',
    location: {
      address: 'Lingerie Party',
    },
    url: images.lingerieParty,
    type: 'Evening Activity',
    category: 'Other',
    customImage: 'lingerieParty',
  },
  {
    title: 'Mimosa Breakfast',
    location: {
      address: 'Mimosa Breakfast',
    },
    url: images.mimosaBreakfast,
    type: 'Evening Activity',
    category: 'Other',
    customImage: 'mimosaBreakfast',
  },
  {
    title: 'Bachelorette Games',
    location: {
      address: 'Bachelorette Games',
    },
    url: images.bacheloretteGames,
    type: 'Evening Activity',
    category: 'Other',
    customImage: 'bacheloretteGames',
  },
  {
    title: 'The Sunday After Brunch',
    location: {
      address: 'The Sunday After Brunch',
    },
    url: images.theSundayAfterBrunch,
    type: 'Evening Activity',
    category: 'Other',
    customImage: 'theSundayAfterBrunch',
  },
];

export const fakeBachelorActivities = [
  {
    title: 'Afternoon Hike',
    location: {
      address: 'Afternoon Hike',
    },
    url: images.afternoonHike,
    type: 'Evening Activity',
    category: 'Other',
    customImage: 'afternoonHike',
  },
  {
    title: 'Bar Crawl',
    location: {
      address: 'Bar Crawl',
    },
    url: images.barCrawl,
    type: 'Evening Activity',
    category: 'Other',
    customImage: 'barCrawl',
  },
  {
    title: 'Gambling Time',
    location: {
      address: 'Gambling Time',
    },
    url: images.gamblingTime,
    type: 'Evening Activity',
    category: 'Other',
    customImage: 'gamblingTime',
  },
  {
    title: 'Beer Garden',
    location: {
      address: 'Beer Garden',
    },
    url: images.beerGarden,
    type: 'Evening Activity',
    category: 'Other',
    customImage: 'beerGarden',
  },
];
